import { getMessage } from './get-message'
const json_data = require(`../assets/${CONFIG.language}.json`);

const findVars = /(\{[\S]+\})/g

export const translate = (id, args, fallback) => {
    const str = getMessage(id)
    if (str === undefined || str == null) {
        warn(id, 'No translation found')
        if (fallback) {
        try {
            const fallbackTranslation = getMessage(fallback)
            return fallbackTranslation || ''
        } catch {
            return id
        }
        }
        return id
    }
    // 'a string with {a} variable' -> ['a string with ', '{a}', ' variable']
    const segments = str.split(findVars).filter((a) => a)
    const response = segments.map((segment) => {
        if (segment.startsWith('{')) {
        // '{var}' -> 'var'
        const key = segment.replace('{', '').replace('}', '')
        return args[key] !== undefined ? args[key] : segment
        } else {
        return segment
        }
    })

    return response.join('')
}
 export const fetchTranslationFromPhrase = () => {
    if(window?.ikea?.purchaseAgent?.text){
        return Promise.resolve()
    } else {
        return getToastMessagesText()
         
    }
  
}

export const getToastMessagesText = () => {
  window.ikea.purchaseAgent = window.ikea.purchaseAgent || {};
  window.ikea.purchaseAgent.text = json_data;
};